/* Archivo: assets/article-toc.js */

(function () {
  'use strict';

  /**
   * Convierte texto en un ID válido para anclas.
   * Ejemplo:
   * "Cómo elegir una batería" -> "como-elegir-una-bateria"
   */
  function slugify(text) {
    return text
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' y ')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /**
   * Genera un ID único para evitar conflictos con otros elementos.
   */
  function getUniqueId(baseId, usedIds) {
    var cleanBaseId = baseId || 'seccion';
    var finalId = cleanBaseId;
    var counter = 2;

    while (usedIds.has(finalId) || document.getElementById(finalId)) {
      finalId = cleanBaseId + '-' + counter;
      counter += 1;
    }

    usedIds.add(finalId);

    return finalId;
  }

  /**
   * Obtiene el nivel de un heading.
   * H2 -> 2, H3 -> 3, H4 -> 4.
   */
  function getHeadingLevel(heading) {
    return parseInt(heading.tagName.replace('H', ''), 10);
  }

  /**
   * Crea cada enlace de la tabla de contenidos.
   */
  function createTocItem(heading, level, minLevel) {
    var item = document.createElement('li');
    var link = document.createElement('a');

    item.className = 'article-toc__item article-toc__item--level-' + level;
    item.style.setProperty('--toc-indent-level', Math.max(level - minLevel, 0));

    link.className = 'article-toc__link';
    link.href = '#' + heading.id;
    link.textContent = heading.textContent.trim();
    link.setAttribute('data-toc-link', heading.id);

    item.appendChild(link);

    return item;
  }

  /**
   * Activa visualmente el enlace correspondiente a la sección actual.
   */
  function setActiveLink(toc, id) {
    var links = toc.querySelectorAll('[data-toc-link]');

    links.forEach(function (link) {
      var isActive = link.getAttribute('data-toc-link') === id;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  /**
   * Muestra la tabla cuando está correctamente inicializada.
   */
  function showToc(toc) {
    toc.hidden = false;
    toc.classList.add('is-ready');
    toc.classList.remove('is-empty');
  }

  /**
   * Oculta la tabla si no hay encabezados o hay error de configuración.
   */
  function hideToc(toc) {
    toc.hidden = true;
    toc.classList.remove('is-ready');
    toc.classList.add('is-empty');
  }

  /**
   * Inicializa una tabla de contenidos.
   */
  function initToc(toc) {
    if (!toc || toc.dataset.tocInitialized === 'true') {
      return;
    }

    var contentSelector = toc.getAttribute('data-toc-content-selector');
    var headingSelector = toc.getAttribute('data-toc-heading-selector');
    var list = toc.querySelector('[data-toc-list]');
    var nav = toc.querySelector('[data-toc-nav]');
    var toggle = toc.querySelector('[data-toc-toggle]');

    if (!contentSelector || !headingSelector || !list) {
      hideToc(toc);
      return;
    }

    var content = document.querySelector(contentSelector);

    if (!content) {
      hideToc(toc);
      return;
    }

    var headings = Array.prototype.slice.call(
      content.querySelectorAll(headingSelector)
    ).filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });

    /**
     * Si quieres mostrar la tabla incluso con 1 solo encabezado,
     * cambia esta condición a:
     *
     * if (headings.length < 1) {
     */
    if (headings.length < 2) {
      hideToc(toc);
      return;
    }

    list.innerHTML = '';

    var usedIds = new Set();
    var headingLevels = headings.map(getHeadingLevel);
    var minLevel = Math.min.apply(null, headingLevels);

    headings.forEach(function (heading) {
      var existingId = heading.getAttribute('id');
      var baseId = existingId ? existingId : slugify(heading.textContent);
      var finalId = getUniqueId(baseId, usedIds);

      heading.setAttribute('id', finalId);
      heading.classList.add('article-toc-target');

      list.appendChild(
        createTocItem(heading, getHeadingLevel(heading), minLevel)
      );
    });

    /**
     * Botón mostrar/ocultar.
     */
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!isExpanded));
        toc.classList.toggle('is-collapsed', isExpanded);
      });
    }

    /**
     * Scroll suave al hacer clic en un enlace.
     */
    list.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');

      if (!link) {
        return;
      }

      var targetId = link.getAttribute('href').replace('#', '');
      var target = document.getElementById(targetId);

      if (!target) {
        return;
      }

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      history.pushState(null, '', '#' + targetId);

      setActiveLink(toc, targetId);
    });

    /**
     * Resaltar sección activa mientras se hace scroll.
     */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var visibleEntries = entries
            .filter(function (entry) {
              return entry.isIntersecting;
            })
            .sort(function (a, b) {
              return a.boundingClientRect.top - b.boundingClientRect.top;
            });

          if (visibleEntries.length > 0) {
            setActiveLink(toc, visibleEntries[0].target.id);
          }
        },
        {
          root: null,
          rootMargin: '-20% 0px -70% 0px',
          threshold: 0
        }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    /**
     * Si la página se abre con una URL que ya contiene #ancla.
     */
    if (window.location.hash) {
      var initialId = decodeURIComponent(window.location.hash.replace('#', ''));

      if (document.getElementById(initialId)) {
        setActiveLink(toc, initialId);
      }
    }

    showToc(toc);

    toc.dataset.tocInitialized = 'true';
  }

  /**
   * Inicializa todas las tablas de contenidos en la página.
   */
  function initAllTocs() {
    var tocs = document.querySelectorAll('[data-article-toc]');

    tocs.forEach(function (toc) {
      initToc(toc);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTocs);
  } else {
    initAllTocs();
  }

  /**
   * Compatibilidad con el editor visual de Shopify.
   */
  document.addEventListener('shopify:section:load', function () {
    initAllTocs();
  });
})();